var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/SendButton/SendButton.jinja"] = require( "front/components/SendButton/SendButton.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexFinders/IndexFinders.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexFinders/IndexFinders.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"IndexFinders\">\n    <div class=\"IndexFinders-desc IndexFinders-text\">\n        <div class=\"IndexFinders-title\">Работа для устремлённых и общительных</div>\n        <p>Если не хотите бессмысленно сидеть в офисе, заниматься нудными делами, а хотите много зарабатывать и общаться с людьми, отправьте свой номер телефона. Мы перезвоним\n            <span>сегодня</span>.\n        </p>\n    </div>\n    <div class=\"IndexFinders-bonus IndexFinders-text\">\n        Каждый месяц лучший сотрудник получает подарок и отметку лучшего эксперта на сайте.\n    </div>\n    <div class=\"IndexFinders-form\">\n        <input class=\"IndexFinders-phone\" placeholder=\"Номер телефона\" name=\"phone\" id=\"phone\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/SendButton/SendButton.jinja", false, "assets/app/front/components/IndexFinders/IndexFinders.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
callback(null,t_4);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
callback(null,t_6);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexFinders/IndexFinders.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexFinders/IndexFinders.jinja
// module id = 28
// module chunks = 0